import React, { useState, useEffect } from 'react';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('anasayfa');

  const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Navbar yüksekliği
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScrollSpy = () => {
      const sections = ['anasayfa', 'galeri', 'yorumlar', 'iletisim'];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScrollSpy);
    return () => window.removeEventListener('scroll', handleScrollSpy);
  }, []);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <a 
          href="#anasayfa" 
          className="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            handleScroll('anasayfa');
          }}
        >
          ⛸️ Buz Pateni Eğitmeni
        </a>
        <button 
          className="nav-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <a 
              href="#anasayfa"
              className={activeSection === 'anasayfa' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleScroll('anasayfa');
              }}
            >
              Ana Sayfa
            </a>
          </li>
          <li>
            <a 
              href="#galeri"
              className={activeSection === 'galeri' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleScroll('galeri');
              }}
            >
              Galeri
            </a>
          </li>
          <li>
            <a 
              href="#yorumlar"
              className={activeSection === 'yorumlar' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleScroll('yorumlar');
              }}
            >
              Yorumlar
            </a>
          </li>
          <li>
            <a 
              href="#iletisim"
              className={activeSection === 'iletisim' ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleScroll('iletisim');
              }}
            >
              İletişim
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;

